<template>
  <section
    class="content"
    v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]"
  >
    <div>
      <div class="box-body">
        <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]"
        >
          <router-link :to="{ name: 'RouteCreate' }">
            <button class="btn btn">Add New</button>
          </router-link>
        </div>
        <v-server-table
          ref="tripRouteTable"
          url
          :columns="columns"
          :options="options"
          v-on:row-click="edit"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import { mapState } from 'vuex';
export default {
  name: 'tripRoute',
  data() {
    return {
      USER_ROLES: USER_ROLES,
      loading: null,
      tripRouteTable: null,
      columns: [
        'name',
        'region',
        'approxDistance',
        'startSite',
        'endSite',
        'status',
      ],
      options: {
        highlightMatches: true,
        sortable: [
          'name',
          'region',
          'approxDistance',
          'startSite',
          'endSite',
          'status',
        ],
        headings: {
          name: 'Route',
          region: 'Geographic Area',
          approxDistance: 'Length (km)',
          startSite: 'Start Location',
          endSite: 'End Location',
          status: 'Status',
          region: 'Geographical Area',
        },
        templates: {
          region(row, query) {
            return `${query.regionName}`;
          },
          startSite(row, query) {
            return `${query.startSiteSiteName}`;
          },
          endSite(row, query) {
            return `${query.endSiteSiteName}`;
          },

          status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
        },
        requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          if(this.user.roleName == "GA Head"){
            params.regionRegionManager = this.user._id
          }
          if (request.orderBy) {
            params.$sort = request.ascending
              ? '-' + request.orderBy
              : request.orderBy;
          } else {
            params.$sort = 'createdAt';
          }
          if (request.query) {
            params.$term = request.query;
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          this.loading = true;
          return this.$triprouteDataRepository.list(params).catch(error => {
            this.$snotify.error('Get Routes', 'Error!');
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.docs,
            count: response.data.items.total,
          };
        },
        uniqueKey: '_id',
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.tripRouteTable) {
        return this.tripRouteTable.count > this.tripRouteTable.limit ||
          this.tripRouteTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
    ...mapState({
      user: state => state.auth.user,
      
    }),
  },
  methods: {
    edit(data) {
      this.$router.push({
        name: 'RouteDetail',
        params: { _id: data.row._id },
        props: data.row,
      });
    },
    onLoaded() {
      this.tripRouteTable = this.$refs.tripRouteTable;
    },
  }
}
</script>
<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}
.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
.btn {
  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
  color: white
}
</style>


// WEBPACK FOOTER //
// tripRoute.vue?2c121c31